export const columns = [
  {
    title: '项目名称',
    dataIndex: 'name',
    scopedSlots: { customRender: 'name' },
    ellipsis: true,
  },
  {
    title: '受益人',
    dataIndex: 'proprietor',
    scopedSlots: { customRender: 'proprietor' },
    ellipsis: true,
  },
  {
    title: '开标日期',
    dataIndex: 'bidder_timef',
    scopedSlots: { customRender: 'bidder_timef' },
    ellipsis: true,
    width: 170,
  },
  {
    title: '担保额度',
    dataIndex: 'money',
    scopedSlots: { customRender: 'money' },
    ellipsis: true,
    width: 120,
  },
  {
    title: '操作',
    dataIndex: 'id',
    scopedSlots: { customRender: 'action' },
    width: 60,
  },
];
